interface IOrderConstant {
  TYPE: {
    ORDER: string;
    QUOTATION: string;
    INVOICE: string;
    DELIVERY_NOTE: string;
  };
  REFERENCE_TYPE: {
    REQUEST_FOR_QUOTE: string;
    ASK_FOR_QUOTE: string;
  };
  STATUS: {
    DRAFT: string;
    CONFIRMED_BY_CUSTOMER: string;
  };
  BUYER: {
    CONTACT_TYPE: {
      BILLING: string;
      SHIPPING: string;
    };
  };
}

const ORDER: IOrderConstant = {
  TYPE: {
    ORDER: 'order',
    QUOTATION: 'quotation',
    INVOICE: 'invoice',
    DELIVERY_NOTE: 'delivery_note',
  },
  REFERENCE_TYPE: {
    REQUEST_FOR_QUOTE: 'request_for_quote',
    ASK_FOR_QUOTE: 'ask_for_quote',
  },
  STATUS: {
    CONFIRMED_BY_CUSTOMER: 'confirmed-by-customer',
    DRAFT: 'draft',
  },
  BUYER: {
    CONTACT_TYPE: {
      BILLING: 'billing',
      SHIPPING: 'shipping',
    },
  },
};

export default ORDER;
